module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/reviewer-2-a9ea12aba746ac8a0d866ccf6fb24b51.webp";